import React, { useEffect, useState } from "react";
import { Box, Typography, Grid, Card } from "@mui/material";
import SideNav from "../../../components/sideNav";
import DashboardMetrics from "./DashboardMetrics";
import PlatformActivity from "./PlatformActivity";
import RecentActivities from "./RecentActivities";
import ParentWrapper from "../../../components/ParentWrapper";
import Header from "../../../components/header";

function SuperAdminDashboard() {
  return (
    // <Box>
    //   <Box>
    //     <Box
    //       sx={{
    //         ml: {
    //           xs: "0px",
    //           md: "230px",
    //         },
    //       }}
    //     >
    //       <Box
    //         sx={{
    //           mb: 2,
    //           mt: {
    //             xs: 0,
    //             md: 1,
    //           },
    //           p: 3,
    //         }}
    //       >
    //         <Typography
    //           variant="body2"
    //           style={{
    //             color: "grey",
    //           }}
    //         >
    //           {"Home > Dashboard"}
    //         </Typography>
    //         <DashboardMetrics />
    //         <PlatformActivity />
    //         <RecentActivities />
    //       </Box>


    //     </Box>
    //   </Box>
    // </Box>
    <ParentWrapper>
        <Box
            sx={{
              mb: 2,
              mt: {
                xs: 0,
                md: 1,
              },
              p: 3,
            }}
          >
            {/* <Typography
              variant="body2"
              style={{
                color: "grey",
              }}
            >
              {"Home > Dashboard"}
            </Typography> */}
            
             <Header title={"Home > Dashboard"} />

            <DashboardMetrics />
            <PlatformActivity />
            <RecentActivities />
          </Box>
    </ParentWrapper>
  );
}

export default SuperAdminDashboard;
